module.exports = __webpack_public_path__ + "static/media/aiDesignertemplate3.dbacb4c5.png";